import React from 'react';
import { Typography } from '@material-ui/core';
import { SingleGraphPayload } from '../types';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  itemRow: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'baseline',
  },
  itemColorSample: {
    display: 'block',
    height: 10,
    width: 10,
    marginRight: 8,
    backgroundColor: ({ name }: any) =>
      name?.toLowerCase() === 'benchmark'
        ? theme.palette.brand.greenLightAnalytic
        : theme.palette.brand.blueDeepSeaAnalytic,
  },
  itemLabel: {
    color: 'rgba(255,255,255, 0.8)',
    lineHeight: `${theme.spacing(1.75)}px`,
    marginRight: 8,
  },
  itemValue: {
    color: 'white',
    lineHeight: `${theme.spacing(1.75)}px`,
    marginLeft: 'auto',
  },
}));

export default function CogTooltipItem({ name, value }: SingleGraphPayload) {
  const classes = useStyles({ name });
  return (
    <div className={classes.itemRow}>
      <div className={classes.itemColorSample} />
      <Typography variant="subtitle1" className={classes.itemLabel}>
        {name}
      </Typography>
      <Typography variant="subtitle1" className={classes.itemValue}>
        {value}%
      </Typography>
    </div>
  );
}
